import React, {
  ChangeEvent,
  ComponentType,
  ForwardedRef,
  forwardRef,
  useEffect,
  useState,
} from 'react'
import { useDebounce } from '../hooks/UseDebounce'

export interface IWithSearchProps {
  searchValue?: string
  debouncedSearch?: string
  onClear?: () => void
  onSearch?: (value: string) => void
}

export function withSearch<T>(WrappedComponent: ComponentType<T & IWithSearchProps>) {
  return forwardRef((props: T & IWithSearchProps, ref: ForwardedRef<IWithSearchProps>) => {
    const { searchValue, onSearch, ...rest } = props
    const [currentSearch, setCurrentSearch] = useState<string>(searchValue ? searchValue : '')
    const debouncedSearch = useDebounce(currentSearch, 500)

    useEffect(() => {
      onSearch?.(debouncedSearch)
    }, [debouncedSearch])

    return (
      <WrappedComponent
        {...(rest as T & IWithSearchProps)}
        ref={ref}
        debouncedSearch={debouncedSearch}
        onClear={() => setCurrentSearch('')}
        onInput={(e: ChangeEvent<HTMLInputElement>) => setCurrentSearch(e.target.value)}
      ></WrappedComponent>
    )
  })
}
